<template>
  <div id="bottomRight">
    <div class="bg-color-black">
      <div class="d-flex pt-2 pl-2">
        <span>
          <icon name="chart-area" class="text-icon"></icon>
        </span>
        <div class="d-flex">
          <span class="text mx-2">时间段能耗分析</span>
        </div>
      </div>
      <div class="d-flex jc-center body-box">
               <dv-scroll-board class="dv-scr-board" :config="config" style="align:left;width:850px;height:440px"/>
      </div>
    </div>
  </div>
</template>

<script>

export default {
 data() {
    return {
      config: {
        header: [ '时间段', '耗水','耗电','耗汽','每平米耗水','每平米耗电','每平米耗汽','室外温度'],
        data: [
          [ '早上(6点-8点)', 46,530,23,1.2,4,1.2,17.5],
          [ '上午(8点-12点)', 130,1900,130,3.4,8,1.5,22],
          [ '中午(12点-14点)',21,880, 45,0.6,2,1.8,26.5],
          [ '下午(14点-18点)',167,2470, 190,5.2,9,2.3,24.6],
          [ '晚上(18点-22点)',23,1280, 80,0.5,4.2,1.3,19.5],
          [ '夜间(23点-6点)',16,790, 348,0.2,2.5,0.8,14.3]
        ],
        rowNum: 8, //表格行数
        headerHeight: 35,
        headerBGC: '#0f1325', //表头
        oddRowBGC: '#0f1325', //奇数行
        evenRowBGC: '#171c33', //偶数行
        columnWidth: [140],
        align: ['left']
      }
    }
  }
};
</script>

<style lang="scss" class>
$box-height: 520px;
$box-width: 100%;
#bottomRight {
  padding: 14px 16px;
  height: $box-height;
  width: $box-width;
  border-radius: 5px;
  .bg-color-black {
    height: $box-height - 30px;
    border-radius: 10px;
  }
  .text {
    color: #c3cbde;
  }
  //下滑线动态
  .decoration2 {
    position: absolute;
    right: 0.125rem;
  }
  .chart-box {
    margin-top: 16px;
    width: 170px;
    height: 170px;
    .active-ring-name {
      padding-top: 10px;
    }
  }
   .body-box {
    border-radius: 10px;
    overflow: hidden;
    margin-left:0px;
    margin-top:10px;
    .dv-scr-board {
      width: 520px;
      height: 340px;
    }
  }
}
</style>